import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation,
} from "@angular/core";

@Component({
  selector: "app-tinymce-editor",
  templateUrl: "./tinymce-editor.component.html",
  styleUrls: ["./tinymce-editor.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TinymceEditorComponent implements AfterViewInit, OnDestroy {
  @Input() elementId: String;
  @Input() value: String;
  @Input() toolbar: string[] | boolean;
  @Input() editMode: boolean;
  @Output() onEditorKeyup = new EventEmitter<any>();
  @Output() placeholder: String;
  @Input() maxLength: number;
  @Input() currentLength: number;
  editor;

  /**
   * Wait the after view init to load Tiny MCE
   */
  ngAfterViewInit() {
    this.initTinyMce();
    // small hack for Press duplicate
    if (this.elementId === "2-Press-Description") {
      setInterval(() => {
        if (tinymce.get("2-Press-Description")) {
          if (localStorage.getItem("isPressDuplicate") === "true") {
            tinymce.get("2-Press-Description").contentDocument.body.innerText =
              localStorage.getItem("digitalDescriptionContent");
            tinymce.get("2-Press-Description").readonly = true;
          } else {
            if (
              localStorage.getItem("descriptionPressHasBeenReseted") === "false"
            ) {
              tinymce.get(
                "2-Press-Description"
              ).contentDocument.body.innerText = localStorage.getItem(
                "initialPressDescriptionContent"
              );
              localStorage.setItem("descriptionPressHasBeenReseted", "true");
            }
            tinymce.get("2-Press-Description").readonly = false;
          }
        }
      }, 200);
    }

    if (this.elementId === "2-Partners-Description") {
      setInterval(() => {
        if (tinymce.get("2-Partners-Description")) {
          if (localStorage.getItem("isPartnersDuplicate") === "true") {
            tinymce.get(
              "2-Partners-Description"
            ).contentDocument.body.innerText = localStorage.getItem(
              "digitalDescriptionContent"
            );
            tinymce.get("2-Partners-Description").readonly = true;
          } else {
            if (
              localStorage.getItem("descriptionPartnersHasBeenReseted") ===
              "false"
            ) {
              tinymce.get(
                "2-Partners-Description"
              ).contentDocument.body.innerText = localStorage.getItem(
                "initialPartnersDescriptionContent"
              );
              localStorage.setItem("descriptionPartnersHasBeenReseted", "true");
            }
            tinymce.get("2-Partners-Description").readonly = false;
          }
        }
      }, 200);
    }
  }

  /**
   * Initialize tiny MCE
   */
  initTinyMce() {
    tinymce.init({
      selector: "#" + this.elementId,
      plugins: ["autoresize", "noneditable"],
      height: 75,
      readonly: !this.editMode,
      verify_html: true,
      branding: false,
      menubar: false,
      force_br_newlines: true,
      force_p_newlines: false,
      forced_root_block: "",
      toolbar: this.toolbar,
      autoresize_min_height: 75,
      autoresize_max_height: 80,
      autoresize_bottom_margin: 0,
      skin_url: "/assets/tinymce/skin/lightgray",
      content_css: "/assets/tinymce/css/content.css",
      statusbar: false,
      entity_encoding: "raw",
      setup: (editor) => {

        let maxLength = this.maxLength;
        this.editor = editor;
        /**
         * Listen the changes and emit them
         */
        editor.on("keydown", function (e) {
          //Stop writing more than 3 lines of caract
          if (
            tinymce_getContentLength() + 1 > this.settings.max_chars &&
            e.keyCode != 8 &&
            e.keyCode != 46
          ) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
          //block enter key when we have 2 carriage return
          if (tinymce_getRetourChariot() && e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();
          }
          //Block at maxLength
          if (tinymce_getContentLength() >= maxLength && e.keyCode != 8 && e.keyCode != 46) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }

          return true;
        });
        editor.on("keyup", () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
        editor.on("change", () => {
          let content = editor.getContent();
          if (tinymce_getContentLength() > this.maxLength) {
            // Tronquer le contenu
            content = content.substring(0, this.maxLength);
            // Mettre à jour le contenu de l'éditeur
            editor.setContent(content);
          }
          this.onEditorKeyup.emit(content);
        });

        editor.on("paste", (e) => {
          // Use setTimeout to allow the content to be pasted before truncating it
          setTimeout(() => {
            let content = editor.getContent();

            // Check if the length exceeds this.maxLength
            if (tinymce_getContentLength() > this.maxLength) {
              // Truncate the content
              content = content.substring(0, this.maxLength);
              // Update the editor content
              editor.setContent(content);
            }

            // Emit the event
            this.onEditorKeyup.emit(content);
          }, 0);
        });

        editor.on("input", () => {
          let content = editor.getContent();

          // Check if the length exceeds this.maxLength
          if (tinymce_getContentLength() > this.maxLength) {
            // Truncate the content
            content = content.substring(0, this.maxLength);
            // Update the editor content
            editor.setContent(content);
          }

          // Emit the event
          this.onEditorKeyup.emit(content);
        });

      },
    });

    function tinymce_getContentLength(): number {
      return tinymce.get(tinymce.activeEditor.id).contentDocument.body.innerText
        .length;
    }

    function tinymce_getRetourChariot() {
      let text = tinymce.get(tinymce.activeEditor.id).contentDocument.body
        .innerHTML;
      let count = (text.match(/<br/g) || []).length;
      // we need to have 2 <br> max AND not ending with <br>
      return (
        (count == 2 &&
          !(
            text.endsWith('<br data-mce-bogus="1">') || text.endsWith("<br>")
          )) ||
        (count == 3 &&
          (text.endsWith('<br data-mce-bogus="1">') || text.endsWith("<br>")))
      );
    }
  }

  /**
   * Remove the editor on destroy event
   */
  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tinymce-editor/tinymce-editor.component.ts